export default "__VITE_ASSET__tamz9JnK__"